import { Text } from "../typography";

type ChildProps = { children: React.ReactNode };

export const Ul = ({ children }: ChildProps) => (
	<ul className="mb-4 ml-5 flex list-outside list-disc flex-col gap-1 text-left">{children}</ul>
);

export const Ol = ({ children, ...rest }: ChildProps) => (
	<ol {...rest} className="mb-4 ml-5 flex list-outside list-decimal flex-col gap-4 text-left">
		{children}
	</ol>
);

export const Li = ({ children }: ChildProps) => (
	<li className="list-item">
		<Text>{children}</Text>
	</li>
);
